import React from "react";

function Footer() {
  return (
    <footer style={{ padding: "10px", textAlign: "center", color: "black", fontSize: "0.8rem" }}>
      &copy; {new Date().getFullYear()} TOM - Wellness At Your Doorstep
    </footer>
  );
}

export default Footer;
